import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

import TablePercentil from "../../../components/TablePercentil";

import AvaliacaoGeneticaService from "../../../services/AvaliacaoGeneticaService";

export default function AnimaisPercentil({ racas }) {
  const [consulta, setConsulta] = useState("");
  const [dropdownRaca, setDropdownRaca] = useState(false);
  const [inputDropdownRaca, setInputDropdownRaca] = useState("");
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleInputRaca = (value) => {
    setInputDropdownRaca(value.nome);
    setConsulta(value.id);
  };

  const send = () => {
    setLoading(true);
    AvaliacaoGeneticaService.animaisPercentil(consulta)
      .then((response) => {
        if (response && response.length > 0) {
          setResult(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        // setError(error);
        setLoading(false);
      });
  };

  return (
    <div className="main-content">
      {loading && (
        <div className={"loading-mask"}>
          <FontAwesomeIcon icon={faCircleNotch} pulse />
        </div>
      )}
      <div className="container__title-content">
        <h2 className="global-title global-title-underline">
          Tabela percentil
        </h2>
      </div>

      <div className="global-container">
        <div className="global-input-container">
          <div
            className="input"
            onClick={() => {
              if (!dropdownRaca) {
                setDropdownRaca(true);
              } else if (dropdownRaca) {
                setDropdownRaca(false);
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={inputDropdownRaca}
              placeholder="Raças"
              type="text"
            />
            <div className="arrow-down" />
            {dropdownRaca ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {racas &&
                    racas.length > 0 &&
                    racas.map((r, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleInputRaca(r);
                            setDropdownRaca(false);
                          }}
                        >
                          {r.nome}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <button className="global-btn-info" onClick={send}>
          Pesquisar
        </button>
      </div>

      <TablePercentil result={result} inputDropdownRaca={inputDropdownRaca} />
    </div>
  );
}
